export const SESSION_FILTERS_KEY = 'edhFilters';      // legacy — kept for migration
export const SENT_FILTERS_KEY = 'edhFilters_sent';
export const PENDING_FILTERS_KEY = 'edhFilters_pending';
export const FAILED_FILTERS_KEY = 'edhFilters_failed';
